import Drawflow from 'drawflow';
import { toggleModal } from '../modal';
import { debounce } from '../utils';
import { node, getAnswerTemplate } from './templates';
import { initMediumEditor } from '../medium-editor.utils';
import { initEditorJS } from '../editorjs/init';

const nodeType = 'node';
let mediumEditor;
let editorjs;
let dataContainer = document.querySelector('.data-container');
let buttonContainers = document.querySelectorAll('.buttons-container');

export default class RedigoPADrawflow extends Drawflow {
  constructor(container, render = null, parent = null) {
	super(container, render, parent);

	container.addEventListener('pointerdown', this.pointerdown);
	container.addEventListener('pointerup', this.pointerup);
  }

  getNodeElementFromId(id) {
	return this.container.querySelector(`#node-${id}`);
  }
  getNodeIdFromNodeElement(element) {
	return element.id.slice(5);
  }

  initNode(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	nodeElement.addEventListener('click', (e) => {
	  if (e.target.classList.contains('add-answer-btn') ||
		e.target.parentElement.classList.contains('add-answer-btn')) {
		this.addAnswer(e);
	  }
	  if (e.target.classList.contains('remove-answer-btn') ||
		e.target.parentElement.classList.contains('remove-answer-btn')) {
		this.deleteAnswer(e);
	  }
	  if (e.target.classList.contains('select-customfield-btn') ||
		e.target.parentElement.classList.contains('select-customfield-btn')) {
		this.selectCustomField(e);
	  }
	});

	nodeElement.addEventListener('change', (e) => {
	  if (e.target.hasAttribute('df-question-type')) {
		this.changeQuestionType(e);
	  }
	  if (e.target.name === 'text' ||
		e.target.name === 'rule') {
		this.updateAnswer(e);
	  }
	});


	this.initDescription(nodeId, node, nodeElement);
	this.initSection(nodeId, node, nodeElement);
	this.initQuestion(nodeId, node, nodeElement);
  }

  resetNodeData(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	node.data.customfield = { id: '', type: '' };
	node.data.question.answers = [];

	this.updateNodeDataFromId(nodeId, node.data);
  }

  initDescription(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	let descriptionIcon = nodeElement.querySelector('.i-mdi-question-mark-circle');
	let descriptionInput = nodeElement.querySelector('[df-description]');

	if (descriptionInput.value.length > 2) {
	  descriptionIcon.classList.add('selected');
	} else {
	  descriptionIcon.classList.remove('selected');
	}
  }

  initSection(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	let documentIcon = nodeElement.querySelector('.i-mdi-file-document-edit');
	let sectionInput = nodeElement.querySelector('[df-documentdata]');

	if (sectionInput.value.length > 2) {
	  documentIcon.classList.add('selected');
	} else {
	  documentIcon.classList.remove('selected');
	}
  }

  initQuestion(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	node.data.question.answers.forEach((answer, idx) => {
	  let index = idx + 1;
	  this.createAnswer(answer, index, nodeId, node, nodeElement);
	});
	this.syncronizeOutputs(nodeId, node, nodeElement);

	let selectCustomFieldBtn = nodeElement.querySelector('.select-customfield-btn');

	switch (node.data.question.type) {
	  case 0: //NoQuestion
	  case '0': //NoQuestion
		selectCustomFieldBtn.setAttribute('disabled', 'disabled');
		break;
	  case 1: //OpenQuestion
	  case '1': //OpenQuestion
		selectCustomFieldBtn.setAttribute('disabled', 'disabled');
		break;
	  case 2: //FromCustomField
	  case '2': //FromCustomField
		selectCustomFieldBtn.removeAttribute('disabled');
		break;
	}

	let questionContainer = nodeElement.querySelector(`.question-container`);
	let answersContainer = nodeElement.querySelector(`.answers-container`);

	switch (node.data.question.type) {
	  case 0: //NoQuestion
	  case '0': //NoQuestion
		questionContainer.classList.remove('visible');
		answersContainer.classList.remove('visible');
		break;
	  case 1: //OpenQuestion
	  case '1': //OpenQuestion
		questionContainer.classList.add('visible');
		answersContainer.classList.add('visible');
		break;
	  case 2: //FromCustomField
	  case '2': //FromCustomField
		questionContainer.classList.add('visible');
		answersContainer.classList.add('visible');
		break;
	}

	let questionTextArea = questionContainer.querySelector('[df-question-question]');
	let addAnswerBtn = questionContainer.querySelector('.add-answer-btn');

	switch (node.data.question.type) {
	  case 0: //NoQuestion
	  case '0': //NoQuestion
		questionTextArea.removeAttribute('readonly');
		addAnswerBtn.removeAttribute('disabled');
		break;
	  case 1: //OpenQuestion
	  case '1': //OpenQuestion
		questionTextArea.removeAttribute('readonly');
		addAnswerBtn.removeAttribute('disabled');
		break;
	  case 2: //FromCustomField
	  case '2': //FromCustomField
		questionTextArea.setAttribute('readonly', 'readonly');
		addAnswerBtn.setAttribute('disabled', 'disabled');
		switch (node.data.customfield.type) {
		  case 0://Text
		  case '0':
			addAnswerBtn.removeAttribute('disabled');
			break;
		  case 1://Textarea
		  case '1':
			addAnswerBtn.removeAttribute('disabled');
			break;
		  case 2://Data
		  case '2':
			addAnswerBtn.removeAttribute('disabled');
			break;
		  case 3: //Choice
		  case '3':
			break;
		  case 4: //Number
		  case '4':
			addAnswerBtn.removeAttribute('disabled');
			break;
		  case 5: //Image
		  case '5':
			addAnswerBtn.removeAttribute('disabled');
			break;
		}
		break;
	}

	let ruleSelects = answersContainer.querySelectorAll('[name="rule"]');
	let answerInputs = answersContainer.querySelectorAll('[name="text"]');
	let removeAnswerBtns = answersContainer.querySelectorAll('.remove-answer-btn');

	switch (node.data.question.type) {
	  case 0: //NoQuestion
	  case '0': //NoQuestion
		answerInputs.forEach(answerInput => answerInput.removeAttribute('readonly'));
		removeAnswerBtns.forEach(removeAnswerBtn => removeAnswerBtn.removeAttribute('disabled'));
		break;
	  case 1: //OpenQuestion
	  case '1': //OpenQuestion
		ruleSelects.forEach(answerInput => answerInput.setAttribute('disabled', 'disabled'));
		answerInputs.forEach(answerInput => answerInput.removeAttribute('readonly'));
		removeAnswerBtns.forEach(removeAnswerBtn => removeAnswerBtn.removeAttribute('disabled'));
		break;
	  case 2: //FromCustomField
	  case '2': //FromCustomField
		switch (node.data.customfield.type) {
		  case 0://Text
		  case '0':
			break;
		  case 1://Textarea
		  case '1':
			break;
		  case 2://Data
		  case '2':
			break;
		  case 3: //Choice
		  case '3':
			ruleSelects.forEach(answerInput => answerInput.setAttribute('disabled', 'disabled'));
			answerInputs.forEach(answerInput => answerInput.setAttribute('readonly', 'readonly'));
			removeAnswerBtns.forEach(removeAnswerBtn => removeAnswerBtn.setAttribute('disabled', 'disabled'));
			break;
		  case 4: //Number
		  case '4':
			break;
		  case 5: //Image
		  case '5':
			break;
		}

		break;
	}

	this.recalculateOutputsPosition(nodeId, node, nodeElement);
  }
  resetQuestion(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	let answersContainer = nodeElement.querySelector(`.answers-container`);

	answersContainer.innerHTML = '';
  }

  createAnswer(answer, index, nodeId, node = null, nodeElement = null) {
	if (answer === null)
	  return;

	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	this.createAnswerInput(answer, index, nodeId, node, nodeElement);
	this.saveAnswerInput(answer, index, nodeId, node, nodeElement);
  }
  removeAnswer(index, nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	let answerToRemove = nodeElement.querySelector(`[data-index="${index}"]`);
	let outputClass = `output_${index}`;

	let answerCount = nodeElement.querySelectorAll(`.answer-container`).length;
	if (answerCount > 1) {
	  this.removeNodeOutput(nodeId, outputClass);
	}

	this.updateOtherAnswers(answerToRemove);
	answerToRemove.remove();

	let answers = [];

	let answerInputs = nodeElement.querySelectorAll(`.answer`);
	answerInputs.forEach((answerInput, idx) => {
	  answers.push(answerInput.value);
	})

	node.data.question.answers = answers;
	this.updateNodeDataFromId(nodeId, node.data);

  }

  updateOtherAnswers(element) {
	let nextAnswer = element.nextElementSibling;

	while (nextAnswer != null) {
	  let index = Number(nextAnswer.dataset.index) - 1;
	  nextAnswer.dataset.index = index;
	  let input = nextAnswer.querySelector('[name="text"]');
	  input.placeholder = `Risposta ${index}`;

	  nextAnswer = nextAnswer.nextElementSibling;
	}
  }

  syncronizeOutputs(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	let answerCount = nodeElement.querySelectorAll(`.answer-container`).length;
	let outputCount = nodeElement.querySelectorAll(`.output`).length;

	let lowerLimit = 0;
	switch (node.data.question.type) {
	  case 0: //NoQuestion
	  case '0': //NoQuestion
		lowerLimit = -1;
		break;
	  case 1: //OpenQuestion
	  case '1': //OpenQuestion
		lowerLimit = -1;
		break;
	  case 2: //FromCustomField
	  case '2': //FromCustomField
		lowerLimit = 0;
		break;
	}

	let delta = answerCount - outputCount;

	while (delta > 0) {
	  this.addNodeOutput(nodeId);
	  delta--;
	}
	while (delta < lowerLimit) {
	  this.removeNodeOutput(nodeId, `output_${outputCount}`);
	  outputCount--;
	  delta++;
	}
  }

  createAnswerInput(answer, index, nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	let answersContainer = nodeElement.querySelector(`.answers-container`);
	let html = getAnswerTemplate(index, answer, node);
	answersContainer.insertAdjacentHTML('beforeend', html);
  }
  saveAnswerInput(answer, index, nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	node.data.question.answers.splice(index - 1, 1, answer);
	this.updateNodeDataFromId(nodeId, node.data);
  }
  deleteAnswerInput(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}
  }

  recalculateOutputsPosition(nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	let outputs = nodeElement.querySelectorAll(`.output`);
	outputs.forEach(output => output.style.top = 'unset');

	node.data.question.answers.forEach((answer, idx) => {
	  if (answer === null)
		return;

	  let index = idx + 1;
	  let answerContainer = nodeElement.querySelector(`[data-index="${index}"]`)
	  let target = nodeElement.querySelector(`.output_${index}`);
	  if (target != null) {
		target.style.top = null;
		let pos = answerContainer.getBoundingClientRect();
		let targetPos = target.getBoundingClientRect();
		let top = ((pos.y + pos.height / 2) - targetPos.y) / this.zoom;
		target.style.top = `${top}px`;
	  }
	});

	this.updateConnectionNodes(`node-${nodeId}`);
  }

  resetView = function () {
	this.zoom = 1;
	this.canvas_x = 0;
	this.canvas_y = 0;
	this.precanvas.style.transform = `translate(${this.canvas_x}px, ${this.canvas_y}px) scale(${this.zoom})`;
  }

  setTranslate = function (x, y, zoom) {
	this.canvas_x = x;
	this.canvas_y = y;

	let storedZoom = zoom;
	this.zoom = 1;
	this.precanvas.style.transform = "translate(" + this.canvas_x + "px, " +
	  this.canvas_y + "px) scale(" + this.zoom + ")";
	this.zoom = storedZoom;
	this.zoom_last_value = 1;
	this.zoom_refresh();
  }

  focusNode = function (nodeId, node = null, nodeElement = null) {
	if (node === null) {
	  node = this.getNodeFromId(nodeId);
	}
	if (nodeElement === null) {
	  nodeElement = this.getNodeElementFromId(nodeId);
	}

	const pos_x = -node.pos_x + nodeElement.clientWidth + (50 * this.zoom);
	const pos_y = this.canvas_y;
	this.setTranslate(pos_x, pos_y, this.zoom);

	const millisecondsAnimate = 500
	this.precanvas.style.transition = `all ${millisecondsAnimate / 1000}s ease 0s`
	window.setTimeout(() => {
	  this.precanvas.style.transition = ''
	}, millisecondsAnimate)
  }

  arrangeAllNodes = function (xPadding = 50, yPadding = 50) {
	let nodes = Object.values(this.drawflow.drawflow.Home.data);
	if (nodes.length === 0) {
	  return;
	}

	let rootNodes = [];
	let childNodes = [];

	nodes.forEach((node, idx) => {
	  if (node.inputs.input_1.connections.length == 0) {
		rootNodes.push(node);
	  } else {
		childNodes.push(node);
	  }
	});

	if (rootNodes.length === 0) {
	  console.log('No roots');
	  return;
	}

	let x = 0;
	let y = 0;
	xPadding = xPadding * this.zoom;
	yPadding = yPadding * this.zoom;

	rootNodes.forEach(node => {
	  y = y + this.placeNode(node, x, y, xPadding, yPadding, childNodes);
	});

  }

  /*USATA - DA SISTEMARE*/
  snapNodes = function () {
	var obj = this.drawflow.drawflow.Home.data;
	var positions = { x: [], y: [] };

	// Capture the positions of all nodes
	for (var key in obj) {
	  if (obj.hasOwnProperty(key)) {
		var id = obj[key].id;
		const node = document.getElementById(`node-${id}`);
		var posX = parseInt(node.style.left);
		var posY = parseInt(node.style.top);

		// Insert the positions into the respective arrays
		positions.x.push({ id, posX });
		positions.y.push({ id, posY });
	  }
	}

	// Sort the positions
	positions.x.sort((a, b) => a.posX - b.posX);
	positions.y.sort((a, b) => a.posY - b.posY);

	// Align the positions within the tolerance range
	for (var i = 0; i < positions.x.length - 1; i++) {
	  if (Math.abs(positions.x[i].posX - positions.x[i + 1].posX) <= 40) {
		const node = document.getElementById(`node-${positions.x[i + 1].id}`);
		node.style.left = `${positions.x[i].posX}px`;
		this.drawflow.drawflow[this.module].data[positions.x[i + 1].id].pos_x = positions.x[i].posX;
		this.updateConnectionNodes(`node-${positions.x[i + 1].id}`);
	  }
	}

	for (var i = 0; i < positions.y.length - 1; i++) {
	  if (Math.abs(positions.y[i].posY - positions.y[i + 1].posY) <= 10) {
		const node = document.getElementById(`node-${positions.y[i + 1].id}`);
		node.style.top = `${positions.y[i].posY}px`;
		this.drawflow.drawflow[this.module].data[positions.y[i + 1].id].pos_y = positions.y[i].posY;
		this.updateConnectionNodes(`node-${positions.y[i + 1].id}`);
	  }
	}
  }

  placeNode(node, x, y, xPadding, yPadding, nodes) {

	let element = this.getNodeElementFromId(node.id);
	node.pos_x = x;
	node.pos_y = y;
	element.style.left = `${x}px`;
	element.style.top = `${y}px`;
	this.updateConnectionNodes(`node-${node.id}`);

	let client = element.getBoundingClientRect();

	x += (client.width + xPadding) / this.zoom;

	Object.values(node.outputs).forEach((output) => {
	  output.connections.forEach((connection) => {
		nodes.forEach((node, idx) => {
		  if (node.id == connection.node) {
			nodes.splice(idx, 1);
			y += this.placeNode(node, x, y, xPadding, yPadding, nodes);
			return;
		  }
		});
	  });
	})

	return (client.height + yPadding) / this.zoom;
  }

  /* OVERRIDES */
  export = function () {
	const dataExport = JSON.parse(JSON.stringify(this.drawflow.drawflow.Home.data));
	this.dispatch('export', dataExport);
	return dataExport;
  }

  createReroutePoint = function (ele) {
	console.warn('reroute point disabled');
  }

  dblclick = function (e) {

	if (this.node_selected) {
	  let nodeId = this.getNodeIdFromNodeElement(this.node_selected);
	  this.focusNode(nodeId);
	}
  } 
  /* END OVERRIDES */

  /* EVENT HANDLERS */
  changeQuestionType(event) {
	let nodeElement = event.target.closest('.drawflow-node');
	let nodeId = this.getNodeIdFromNodeElement(nodeElement);
	let node = this.getNodeFromId(nodeId);

	this.resetNodeData(nodeId, node, nodeElement);

	this.resetQuestion(nodeId, node, nodeElement);

	this.initQuestion(nodeId, node, nodeElement);
  }

  addRedigoPANode(x = 0, y = 0) {
	let nodeData = {
	  inputs: 1,
	  outputs: 1,
	  data: {
		name: '',
		description: '',
		customfield: {
		  id: '',
		  type: ''
		},
		position: { x: x, y: y },
		documentdata: '[]',
		question: {
		  type: 0,
		  question: '',
		  answers: []
		}
	  }
	}
	//let answer = {
	//  rule: '',
	//  value: '',
	//  text: '',
	//};
	this.addNode(nodeType, nodeData.inputs, nodeData.outputs, nodeData.data.position.x, nodeData.data.position.y, '', nodeData.data, nodeType, true);
  }

  addAnswer(event) {
	let nodeElement = event.target.closest('.drawflow-node');
	let nodeId = this.getNodeIdFromNodeElement(nodeElement);
	let node = this.getNodeFromId(nodeId);
	let index = node.data.question.answers.length + 1;
	let answer = {
	  rule: '',
	  value: '',
	  text: ''
	};
	this.createAnswer(answer, index, nodeId, node, nodeElement);
	this.syncronizeOutputs(nodeId, node, nodeElement);
  }
  deleteAnswer(event) {
	let nodeElement = event.target.closest('.drawflow-node');
	let nodeId = this.getNodeIdFromNodeElement(nodeElement);
	let node = this.getNodeFromId(nodeId);
	let answerContainer = event.target.closest(`.answer-container`)
	let index = answerContainer.dataset.index;
	this.removeAnswer(index, nodeId, node, nodeElement);
  }
  updateAnswer(event) {
	let nodeElement = event.target.closest('.drawflow-node');
	let nodeId = this.getNodeIdFromNodeElement(nodeElement);
	let node = this.getNodeFromId(nodeId);

	let answerContainer = event.target.closest(`.answer-container`)
	let index = answerContainer.dataset.index;

	let answer = {
	  rule: answerContainer.querySelector('[name="rule"]').value,
	  value: answerContainer.querySelector('[name="value"]').value,
	  text: answerContainer.querySelector('[name="text"]').value
	};

	switch (node.data.question.type) {
	  case 0: //NoQuestion
	  case '0': //NoQuestion
		break;
	  case 1: //OpenQuestion
	  case '1': //OpenQuestion
		answer.value = answer.text;
		answerContainer.querySelector('[name="value"]').value = answer.text;
		break;
	  case 2: //FromCustomField
	  case '2': //FromCustomField
		if (node.data.customfield.type !== 3 /*CHOICE*/) {
		  answer.value = answer.text;
		  answerContainer.querySelector('[name="value"]').value = answer.text;
		}
		break;
	}

	this.saveAnswerInput(answer, index, nodeId, node, nodeElement);
  }

  selectCustomField(event) {
	let nodeElement = event.target.closest('.drawflow-node');
	let nodeId = this.getNodeIdFromNodeElement(nodeElement);
	let node = this.getNodeFromId(nodeId);
	let editor = this;

	document.addEventListener('customfieldselected',
	  (event) => {
		if (event.detail.status !== 'SELECTED') {
		  console.log('Selezione Cancellata')
		  return;
		}

		fetch(`/Templates/CustomFields/Ajax/?handler=CustomFieldById&id=${event.detail.customFieldId}`)
		  .then(response => {
			if (!response.ok)
			  throw new Error(response);
			return response.json()
		  }).then(json => {

			editor.resetNodeData(nodeId, node, nodeElement);
			editor.resetQuestion(nodeId, node, nodeElement);

			node.data.customfield.id = json.id;
			node.data.customfield.type = json.customFieldType;
			node.data.question.question = json.name;

			switch (node.data.customfield.type) {
			  case 0://Text
			  case '0':
				break;
			  case 1://Textarea
			  case '1':
				break;
			  case 2://Data
			  case '2':
				break;
			  case 3: //Choice
			  case '3':
				node.data.question.answers = json.rules.list.map(x => {
				  return {
					rule: '=',
					value: x.key,
					text: x.text
				  }
				});
				break;
			  case 4: //Number
			  case '4':
				break;
			  case 5: //Image
			  case '5':
				break;
			}
			editor.updateNodeDataFromId(nodeId, node.data);
			editor.initQuestion(nodeId, node, nodeElement);
		  })

	  },
	  { once: true });

	toggleModal(document.querySelector('#customFieldsSelection-modal'));
  }

  unselectNode() {
	this.node_selected.classList.remove("selected");
	this.node_selected = null;
	this.dispatch('nodeUnselected', true);
  }
  /* END EVENT HANDLERS */

  /* DRAG AND DROP */
  pointerdown = (event) => {
	if (event.target.classList.contains('parent-drawflow') ||
	  event.target.classList.contains('drawflow')) {
	  this.container.onpointermove = this.position(event);
	  this.container.setPointerCapture(event.pointerId);
	}
  }
  pointerup = (event) => {
	this.container.onpointermove = null;
	this.container.releasePointerCapture(event.pointerId);
  }

  allowDrop(event) {
	event.preventDefault();
  }

  drop(event) {
	let pos_x = event.clientX * (this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)) - (this.precanvas.getBoundingClientRect().x * (this.precanvas.clientWidth / (this.precanvas.clientWidth * this.zoom)));
	let pos_y = event.clientY * (this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)) - (this.precanvas.getBoundingClientRect().y * (this.precanvas.clientHeight / (this.precanvas.clientHeight * this.zoom)));
	this.addRedigoPANode(pos_x, pos_y);
  }
  /* END DRAG AND DROP */
}

export function InitDrawFlow(selector, data) {

  localStorage.removeItem('nodeSelected');

  const drawflowElement = document.querySelector(selector);
  const editor = new RedigoPADrawflow(drawflowElement, data);

  const resizeObserver = new ResizeObserver(debounce((entries) => {
	for (const entry of entries) {
	  if (editor.precanvas.contains(entry.target)) {
		let nodeId = editor.getNodeIdFromNodeElement(entry.target);
		editor.recalculateOutputsPosition(nodeId);
	  }
	}
  }, 100));


  editor.draggable_inputs = false;
  editor.reroute = false;

  editor.registerNode('node', node.content);

  editor.start();

  editor.on('nodeCreated', (nodeId) => {
	let nodeElement = editor.getNodeElementFromId(nodeId);
	let node = editor.getNodeFromId(nodeId);
	resizeObserver.observe(nodeElement);

	editor.initNode(nodeId, node, nodeElement);

  })

  editor.on('import', () => {
	let data = editor.drawflow.drawflow[editor.module].data;
	Object.keys(data).forEach(nodeId => {
	  let node = editor.getNodeFromId(nodeId);
	  let nodeElement = editor.getNodeElementFromId(nodeId);
	  resizeObserver.observe(nodeElement);

	  editor.initNode(nodeId, node, nodeElement);
	});

	// Se l'ultimo nodo è a pos_x == 0 riordino i nodi
	let nodes = Object.values(data);
	if (nodes.at(-1).pos_x == 0) {
	  editor.arrangeAllNodes();
	}

	// DISABILITATO

	//calcolo il numero di colonne e applico uno zoom indietro
	//let columns = nodes
	//  .map(n => n.pos_x)
	//  .filter((value, index, array) => array.indexOf(value) === index);
	//for (let i = 0; i < Math.min(columns.length - 1, 6); i++) {
	//  editor.zoom_out();
	//}
  });

  mediumEditor = initMediumEditor(document.querySelector('#medium-editor'), {
	toolbar: {
	  buttons: ['bold', 'italic', 'underline', 'anchor']
	}
  });

  editorjs = initEditorJS('#editorjs');

  editor.on('nodeSelected', (nodeId) => {
	localStorage.setItem('nodeSelected', nodeId);
	let node = editor.getNodeFromId(nodeId);

	//editor.focusNode(nodeId, node);

	let documentdata = [];
	try {
	  documentdata = JSON.parse(node.data.documentdata);
	} catch { };

	editorjs.blocks.render({
	  blocks: documentdata
	});
	mediumEditor.setContent(node.data.description);

	dataContainer.classList.toggle('open');
	buttonContainers.forEach(x => x.classList.toggle('disabled'));
  })

  editor.on('contextmenu', (event) => {
	  console.log(event)
  });

  editor.on('nodeUnselected', () => {
	let nodeId = localStorage.getItem('nodeSelected');
	localStorage.removeItem('nodeSelected');

	let description = mediumEditor.getContent();

	if (description === '<p><br></p>')
	  description = '';

	editorjs.save()
	  .then(savedData => {
		savedData.blocks.forEach(block => delete block.id);
		let documentdata = JSON.stringify(savedData.blocks);
		let node = editor.getNodeFromId(nodeId);
		let nodeElement = editor.getNodeElementFromId(nodeId);
		node.data.description = description;
		node.data.documentdata = documentdata;
		editor.updateNodeDataFromId(nodeId, node.data);
		editor.initDescription(nodeId, node, nodeElement);
		editor.initSection(nodeId, node, nodeElement);
	  })
	  .catch((err) => {
		console.error(err);
	  })
	  .finally(() => {
		//editorjs.blocks.render({ blocks: [] });
		dataContainer.classList.toggle('open');
		buttonContainers.forEach(x => x.classList.toggle('disabled'));
	  });
  });

  editor.on('nodeRemoved', () => {
	localStorage.removeItem('nodeSelected');
  });


  if (Object.keys(data).length) {
	editor.import({ drawflow: { Home: { data: data } } });
  } else {
	editor.addRedigoPANode();
  }
  document.addEventListener('mousemove', function (e) {
	if (e.target.closest('.parent-drawflow') === null) {
	  editor.dragEnd(e);
	}
  });

  return editor;
}
export function DbToDf(dbData) {

  let dfData = {};

  dbData.nodes
	.forEach((node) => {
	  let inputConnections = [];
	  let outputs = {};
	  node.outputs
		.forEach((output, idx) => {
		  let outputConnections = [];
		  if (output.node) {
			outputConnections.push({
			  node: output.node,
			  output: 'input_1'
			});
		  }
		  let outputKey = `output_${idx + 1}`;
		  outputs[outputKey] = {
			connections: outputConnections
		  };
		});

	  let answers = node.outputs.reduce((result, output) => {
		if (output.answer !== null)
		  result.push(output.answer);
		return result;
	  }, []);

	  let nodeData = {
		name: node.data.name,
		description: node.data.description,
		customfield: node.question.customField ?? { id: '', type: '' },
		documentdata: node.data.documentData,
		position: node.position,
		question: {
		  type: node.question.type,
		  question: node.question.question,
		  answers: answers
		}
	  };


	  dfData[node.key] = {
		id: node.key,
		name: nodeType,
		data: nodeData,
		class: '',
		html: nodeType,
		typenode: true,
		inputs: { 'input_1': { connections: inputConnections } },
		outputs: outputs,
		pos_x: node.position.x,
		pos_y: node.position.y
	  }
	});

  let nodes = Object.values(dfData);

  nodes.forEach((node) => {
	Object.keys(node.outputs)
	  .forEach((outputKey) => {
		let output = node.outputs[outputKey]
		output.connections.forEach((connection) => {
		  nodes.filter((node) => node.id === connection.node)
			.forEach((inputNode) => {
			  inputNode.inputs['input_1'].connections.push({
				node: node.id,
				input: outputKey
			  })
			})
		})
	  })
  });

  return dfData;
}
export function DfToDb(dfData) {
  let dbData = {
	nodes: []
  };

  let nodes = Object.values(dfData);

  nodes.forEach((node, idx) => {
	let outputs = [];
	let inputs = [];

	Object.values(node.outputs).forEach((output, idx) => {
	  let connection = output.connections[0];
	  outputs.push({
		node: connection?.node ?? '',
		answer: node.data.question.answers[idx]
	  });
	})

	Object.values(node.inputs).forEach((input, idx) => {
	  let connection = input.connections[0];
	  if (connection !== undefined && connection !== null) {
		inputs.push(connection.node);
	  }
	})

	let dbNode = {
	  key: `${node.id}`,
	  position: {
		x: Math.round(node.pos_x),
		y: Math.round(node.pos_y)
	  },
	  data: {
		name: node.data.name,
		description: node.data.description,
		documentData: node.data.documentdata,
	  },
	  question: {
		type: Number(node.data.question.type),
		question: node.data.question.question,
		customField: (node.data.customfield?.id ?? false) ? {
		  id: node.data.customfield.id,
		  type: node.data.customfield.type
		} : null,
	  },
	  outputs: outputs,
	  inputs: inputs
	}
	dbData.nodes.push(dbNode);
  });

  return dbData;
}

